import { makeStyles } from '@material-ui/styles'
import { Icon, Button, Modal, Checkbox, FormControlLabel } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTotalTitleBarContext } from '../../../contexts/TotalTitleBarContext.js'
import PropTypes from 'prop-types'
import HeadTitle from '../../../components/HeadTitle/HeadTitle.js'
import { Typography } from '@material-ui/core'
import { InputSelectOnChange } from '../../../components/Form/inputFullPage/InputSelect'
import { MenuItem } from '@material-ui/core'
import { useCookies } from 'react-cookie'
import { PLATFORM_ID_COOKIE, ACTIVE_ACCOUNT_TYPE_COOKIE } from '../../../constants/cookies'
import { ACCOUNTBYTYPEPLATFORM } from '../../../constants/url'
import api from '../../../utils/Requester'
import Form from '../../../components/Form/Form'
import FormButtonFullPage from '../../../components/Form/FormButtonFullPage'
import { Grid, Paper } from '@material-ui/core'
import moment from 'moment'
import DataTable from '../../../components/NewDataTable/NewDataTable'
import { getPdpsByPrincipal, getCompanyRecordList, getCompanyRecordsByPrincipal, changePdpPrincipal, changeCompanyRecordPrincipal } from '../../../containers/DataContainer'
import { UPDATEPDPPRINCIPAL } from '../../../constants/url'
import i18next from 'i18next'
import { useSnackbar } from 'notistack'
import classNames from 'classnames'
import InputCheckbox from '../../../components/Form/inputFullPage/InputCheckbox'
import TotalLoader from '../../../components/TotalLoader/TotalLoader'

const useStyles = makeStyles((theme) => ({
	page: {
		paddingTop: theme.spacing.unit * 2,
		paddingLeft: theme.spacing.unit * 10,
		paddingRight: theme.spacing.unit * 10,
		paddingBottom: theme.spacing.unit * 4,
	},
	paper: {
		height: '100%',
		width: '100%',
		padding: theme.spacing.unit * 2,
		color: theme.palette.secondary.main,
		borderRadius: 5,
		[theme.breakpoints.down('sm')]: {
			marginTop: 25,
		},
	},
	form: {
		margin: 20,
		padding: 20,
		backgroundColor: theme.palette.primary.main,
		borderRadius: 10,
	},
	panel: {
		padding: 20,
		rowGap: 10,
		display: 'grid',
	},
	submitButton: {
		marginTop: 20,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	sentence: {
		marginLeft: theme.spacing.unit * 2,
	},
	IconAndSubText: {},
	ISIcon: {
		display: 'block',
		margin: 'auto',
	},
	ISSubText: {
		textAlign: 'center',
		fontSize: 10,
	},
	checkboxCell: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		'& label': {
			margin: 0,
		},
	},
	dataTable:{
		height: '100%',
	},
	buttonWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'end',
	},
	modalPaper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '35%',
		minWidth: 650,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		outline: 'none',
		padding: 25,
	},
	modalValidateButton: {
		marginLeft: 'auto',
		marginRight: '-5%',
	},
	modalButtonGroup: {
		display: 'flex',
	},
	modalButton: {
		backgroundColor: theme.palette.primary.main,
		borderColor: theme.palette.secondary.main,
		color: theme.palette.secondary.main,
		borderRadius: 30,
		border: 'solid 2px',
		marginTop: 30,
		padding: 10,
		paddingLeft: 25,
		paddingRight: 25,
		marginBottom: 10,
	},
	modalTitle: {
		color: theme.palette.secondary.main,
		marginBottom: 20,
	},
	modalSecondTitle: {
		display: 'inline-block',
	},
	modalLoaderContainer: {
		minHeight: 120,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}))

function PrincipalChange() {
	const classes = useStyles()
	const { t } = useTranslation('user')
	const { setTitleBar } = useTotalTitleBarContext()
	const [cookies] = useCookies()
	const [listDo, setListDO] = useState([])
	const [language, setLanguage] = useState(1)
	const [result, setResult] = useState({ columns: [], data: [], options: {} })
	const [selectedOldPrincipalId, setSelectedOldPrincipalId] = useState('')
	const [selectedNewPrincipalId, setSelectedNewPrincipalId] = useState('')
	const { enqueueSnackbar } = useSnackbar()
	const [pdpSelectedRowsIds, setPdpSelectedRowsIds] = useState([])
	const [datatableDE, setDatatableDE] = useState({ columns: [], data: [], options: {} })
	const [isLoadingDE, setIsLoadingDE] = useState(false)
	const [actualViewDE, setActualViewDE] = useState(null)
	const [deSelectedRowsIds, setDeSelectedRowsIds] = useState([])
	const [modalState, setModalState] = useState(false)
	const [confirmChanges, setConfirmChanges] = useState(false)
	const [SendMailToEE, setSendMailToEE] = useState(false)
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		setTitleBar({
			type: 'titleBar',
			data: {
				icon: 'person',
				title: () => t('specials_treatments'),
			},
		})
	}, [setTitleBar, t])

	useEffect(() => {
		switch (i18next.language) {
			case 'fr':
				setLanguage(1)
				break
			case 'en':
				setLanguage(2)
				break
			default:
				setLanguage(1)
				break
		}
	})

	const recoveryAccountType = (res) => {
		const { data, problem } = res

		if (problem) return

		if (data) {
			setListDO(data)
		}
	}

	useEffect(() => {
		api
			.get(ACCOUNTBYTYPEPLATFORM, {
				p_PlatformId: parseInt(cookies[PLATFORM_ID_COOKIE]),
				p_AccountType: 3 /* DO ID*/,
			})
			.then(recoveryAccountType)
	}, [])

	const handleOldPrincipalChange = (e) => {
		setSelectedOldPrincipalId(e.target.value)
		setResult({ columns: [], data: [], options: {} })
	}

	const handleNewPrincipalChange = (e) => {
		setSelectedNewPrincipalId(e.target.value)
	}

	useEffect(() => {
		if (!selectedOldPrincipalId) {
			setResult({ columns: [], data: [], options: {} })
			return
		}
		getPdpsByPrincipal(
			cookies[PLATFORM_ID_COOKIE],
			selectedOldPrincipalId,
			language,
			(res, err) => {
				if (err) return
				if (res) {
					setResult(res.data)
				}
			},
		)
	}, [cookies, selectedOldPrincipalId, language])

	const MassiveActionsPdp = ({ selectedRows, displayData }) => {
		const prevSelectedCount = React.useRef(0);

		useEffect(() => {
			return () => {
				if (prevSelectedCount.current > 0) {
					setPdpSelectedRowsIds([]);
				}
			};
		}, []);

		useEffect(() => {
			const selectedIndexes = selectedRows.data.map(row => row.index);
			const selectedIds = displayData
				.filter((_, idx) => selectedIndexes.includes(idx))
				.map(row => row.data?.[9]); // 9 = PDP ID
			setPdpSelectedRowsIds(selectedIds);

			prevSelectedCount.current = selectedIds.length;
		}, [selectedRows, displayData]);

		return (
			<Grid container spacing={2} justify="center">
				<Grid item>
					<Typography color="secondary" variant="h6">
						{t('FollowPdP')}
					</Typography>
				</Grid>
			</Grid>
		)
	}

	const customToolbarSelectPdp = (selectedRows, displayData) => (
		<MassiveActionsPdp selectedRows={selectedRows} displayData={displayData} />
	)

	const MassiveActionsDE = ({ selectedRows, displayData }) => {
		const prevSelectedCount = React.useRef(0);

		useEffect(() => {
			return () => {
				if (prevSelectedCount.current > 0) {
					setDeSelectedRowsIds([]);
				}
			};
		}, []);

		useEffect(() => {
			let selectedIndexes = selectedRows.data.map(row => row.index);
			let selectedIds = selectedIndexes
				.filter(idx => datatableDE.data[idx])
				.map(idx => datatableDE.data[idx].depId);
			setDeSelectedRowsIds(selectedIds);

			prevSelectedCount.current = selectedIds.length;
		}, [selectedRows, datatableDE.data]);

		return (
			<Grid container spacing={2} justify="center">
				<Grid item>
					<Typography color="secondary" variant="h6">
						{t('FollowDE')}
					</Typography>
				</Grid>
			</Grid>
		)
	}

	const customToolbarSelectDE = (selectedRows, displayData) => (
		<MassiveActionsDE selectedRows={selectedRows} displayData={displayData} />
	)

	useEffect(() => {
		setActualViewDE(2)
	}, [])

	useEffect(() => {
		if (!selectedOldPrincipalId) {
			setDatatableDE({ columns: [], data: [], options: {} })
			return
		}
		setIsLoadingDE(true)

		getCompanyRecordsByPrincipal(
			cookies[PLATFORM_ID_COOKIE],
			selectedOldPrincipalId,
			language,
			(res, err) => {
				setIsLoadingDE(false)
				if (err) return
				if (res) {
					setDatatableDE(res.data)
				} 
			}
		)
	}, [cookies, selectedOldPrincipalId, language])

	const customColumnsDE = [
		{
			name: 'visitePrealable',
			component: (value) =>
				value ? (
					<div style={{ textAlign: 'center' }}>
						<Icon style={{ color: '#006946' }}>checked_circle</Icon>
					</div>
				) : (
					<div style={{ textAlign: 'center' }}>
						<Icon style={{ color: '#F44436' }}>remove_circle_outline</Icon>
					</div>
				),
		},
		{
			name: 'dateDerniereModif',
			component: (value) => value && moment(value).format('DD/MM/YYYY HH:mm'),
		},
	]

	const customLabelsDE = [
		{ name: 'numeroPdp', label: t('pdpNumero') },
		{ name: 'principalName', label: t('principal') },
		{ name: 'natureIntervention', label: t('natureIntervention') },
		{ name: 'entNom', label: t('entRaisonSociale') },
		{ name: 'dateDerniereModif', label: t('derniereModification') },
		{ name: 'rpdLibelle', label: t('pdp_description') },
		{ name: 'rpdDescriptionLieux', label: t('works_locations') },
		{ name: 'depRevision', label: t('depNumeroRevision') },
		{ name: 'donneurOrdre', label: t('CoordinatorPrincipal') }
	]

	const handleSubmit = (e) => {
		if (!selectedNewPrincipalId) {
			enqueueSnackbar(t('user:principal_change_error_no_new_principal'), { variant: 'error' });
			return;
		}

		if (selectedOldPrincipalId === selectedNewPrincipalId) {
			enqueueSnackbar(t('user:principal_change_error_same_principal'), { variant: 'error' });
			return;
		}

		const hasPdpSelection = Array.isArray(pdpSelectedRowsIds) && pdpSelectedRowsIds.length > 0;
		const hasDeSelection = Array.isArray(deSelectedRowsIds) && deSelectedRowsIds.length > 0;
		if (!hasPdpSelection && !hasDeSelection) {
			enqueueSnackbar(t('user:principal_change_error_no_selection'), { variant: 'error' });
			return;
		}
		setModalState(true)
	}

	const ModalSubmit = () => {
		setIsSubmitting(true);
		setConfirmChanges(true);
		close();
	}

	const close = () => {
		setModalState(false)
	}

	useEffect(() => {
		const doSubmit = async () => {
			if (confirmChanges) {
				let hasChange = false;
				let pdpPromise, dePromise;

				if (pdpSelectedRowsIds && pdpSelectedRowsIds.length > 0 && selectedNewPrincipalId && selectedOldPrincipalId) {
					pdpPromise = new Promise((resolve) => {
						changePdpPrincipal(
							cookies[PLATFORM_ID_COOKIE],
							selectedNewPrincipalId,
							selectedOldPrincipalId,
							SendMailToEE,
							pdpSelectedRowsIds,
							() => resolve()
						)
					});
					hasChange = true;
				}
				if (deSelectedRowsIds && deSelectedRowsIds.length > 0 && selectedNewPrincipalId && selectedOldPrincipalId) {					
					dePromise = new Promise((resolve) => {
						changeCompanyRecordPrincipal(
							cookies[PLATFORM_ID_COOKIE],
							selectedNewPrincipalId,
							selectedOldPrincipalId,
							SendMailToEE,
							deSelectedRowsIds,
							() => resolve(),
						)
					});
					hasChange = true;
				}
				setConfirmChanges(false)
				if (hasChange) {
					Promise.all([pdpPromise, dePromise].filter(Boolean)).then(() => {
						enqueueSnackbar(t('user:principal_change_success'), { variant: 'success' });
						window.location.replace("/specials-treatments/principal-change");
						setIsSubmitting(false);
					});
				} else {
					setIsSubmitting(false);
				}
			}
		}
		doSubmit()
	}, [confirmChanges])

	return (
		<>
			<HeadTitle title={t('specialsTreatments:principal_change')} link="/special-treatment" />
			<Form className={classes.form} onSubmit={handleSubmit}>
				<Grid container justify="center" spacing={16}>
					<Grid item md={6} sm={12}>
						<Paper className={classes.panel}>
							<Typography variant="h6" color="secondary">
								{t('specialsTreatments:old_principal')}
							</Typography>
							<InputSelectOnChange
								name="oldPrincipal"
								label={t('specialsTreatments:old_principal')}
								classes={{ root: classes.inputSelect }}
								required
								value={selectedOldPrincipalId}
								onChange={handleOldPrincipalChange}
							>
								{listDo.map((contact) => (
									<MenuItem value={String(contact.id)} key={`${contact.id}`}>
										{contact.firstName.charAt(0).toUpperCase() + contact.firstName.slice(1).toLowerCase()} {contact.lastName.toUpperCase()} 
									</MenuItem>
								))}
							</InputSelectOnChange>
						</Paper>
					</Grid>
					<Grid item md={6} sm={12}>
						<Paper className={classes.panel}>
							<Typography variant="h6" color="secondary">
								{t('specialsTreatments:new_principal')}
							</Typography>

							<InputSelectOnChange
								name="newPrincipal"
								label={t('specialsTreatments:new_principal')}
								classes={{ root: classes.inputSelect }}
								required
								value={selectedNewPrincipalId}
								onChange={handleNewPrincipalChange}
							>
								{listDo.map((contact) => (
									<MenuItem value={String(contact.id)} key={`${contact.id}`}>
										{contact.firstName.charAt(0).toUpperCase() + contact.firstName.slice(1).toLowerCase()} {contact.lastName.toUpperCase()} 
									</MenuItem>
								))}
							</InputSelectOnChange>
						</Paper>
					</Grid>

					{/* Suivi des PdP */}
					{result.data && result.data.length > 0 && (
						<DataTable
							title={t('FollowPdP')}
							data={result.data}
							columns={result.columns}
							className={classes.dataTable}
							options={{
								...result.options,
								selectableRows: 'multiple',
								customToolbarSelect: customToolbarSelectPdp,
							}}
							customColumns={[
								{
									name: 'rpdStart',
									component: (value) => moment(value).format('DD/MM/YYYY'),
								},
								{
									name: 'rpdEnd',
									component: (value) => moment(value).format('DD/MM/YYYY'),
								},
							]}
							customLabels={[
								{ name: 'pdpNumber', label: t('numero_pdp') },
								{ name: 'lspName', label: t('status') },
								{ name: 'rpdFormattedNumber', label: t('numero_format') },
								{ name: 'rpdLabel', label: t('label') },
								{ name: 'rpdDescription', label: t('works_locations') },
								{ name: 'rpdStart', label: t('date_debut') },
								{ name: 'rpdEnd', label: t('date_fin') },
								{ name: 'PdpDiffusion', label: t('date_diffusion') },
								{ name: 'DatePremiereDiffusion', label: t('date_premiere_diffusion') },
							]}
						/>
					)}

					{/* Suivi des DE */}
					{datatableDE.data && datatableDE.data.length > 0 && (
						<DataTable
							title={t('FollowDE')}
							columns={datatableDE.columns}
							data={datatableDE.data}
							options={{
								...datatableDE.options,
								selectableRows: 'multiple',
								customToolbarSelect: customToolbarSelectDE,
							}}
							isLoading={isLoadingDE}
							customColumns={customColumnsDE}
							customLabels={customLabelsDE}
						/>
					)}

					{selectedOldPrincipalId && selectedNewPrincipalId && selectedOldPrincipalId !== selectedNewPrincipalId && (pdpSelectedRowsIds.length > 0 || deSelectedRowsIds.length > 0) && (
						<Grid item sm={12} className={classes.buttonWrapper}>
							<InputCheckbox
								name="SendMailToEE"
								label={t('user:send_mail_to_ee')}
								checked={SendMailToEE}
								onClick={e => {
									console.log('SendMailToEE checkbox clicked:', e.target.checked)
									setSendMailToEE(e.target.checked)
								}}
							/>
							<FormButtonFullPage
								color="secondary"
								label={t('user:transfer')}
								type="submit"
								style={{ margin: 'unset' }}
							/>
						</Grid>
					)}
				</Grid>
			</Form>
			<Modal open={modalState || isSubmitting} onClose={close}>
				<div className={classes.modalPaper}>
					<Form onSubmit={ModalSubmit}>
						<Typography variant="h6" classes={{ root: classes.modalTitle }}>
							{t('user:ConfirmPrincipalChange')}
						</Typography>
						<div className={classes.modalLoaderContainer}>
							{isSubmitting
								? <TotalLoader />
								: (
									<Typography
										variant="body1"
										classes={{ root: classes.modalSecondTitle }}
										dangerouslySetInnerHTML={{ __html: t('user:ReasonConfirmPrincipalChange') }}
									/>
								)
							}
						</div>
						<div className={classes.modalButtonGroup}>
							<Button
								classes={{ root: classes.modalButton }}
								onClick={close}
								disabled={isSubmitting}
							>
								{t('user:cancel')}
							</Button>
							<Button
								className={classNames(classes.modalButton, classes.modalValidateButton)}
								type="submit"
								disabled={isSubmitting}
							>
								{isSubmitting ? t('user:loading') : t('user:submit')}
							</Button>
						</div>
					</Form>
				</div>
			</Modal>
		</>
	)
}
PrincipalChange.propTypes = {
	match: PropTypes.object,
}

export default PrincipalChange
